import { baseUrl } from '@/shared/constants'
import axios from 'axios'
import { GetDailyBonusInfoDTO, GetFarcanaBonusInfoDTO } from './types'

export const getDailyBonusInfo = async (token: string): Promise<GetDailyBonusInfoDTO> => {
  const response = await axios.get(`${baseUrl}/bonus/get-daily-info`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}
export const getFarcanaBonusInfo = async (token: string): Promise<GetFarcanaBonusInfoDTO> => {
  const response = await axios.get(`${baseUrl}/bonus/get-farcana-info`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })
  return response.data
}

export const postClaimDailyBonus = async (token: string, day: number, isPremium: boolean) => {
  const response = await axios.post(
    `${baseUrl}/bonus/claim-daily-bonus/`,
    {
      day: day,
      is_premium: isPremium,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}

export const postClaimFarcanaBonus = async (token: string, day: number) => {
  const response = await axios.post(
    `${baseUrl}/bonus/claim-farcana-bonus/`,
    {
      day: day,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  )
  return response.data
}
